import { render, staticRenderFns } from "./New.vue?vue&type=template&id=0d3d9d58&scoped=true&"
import script from "./New.vue?vue&type=script&lang=js&"
export * from "./New.vue?vue&type=script&lang=js&"
import style0 from "./New.vue?vue&type=style&index=0&id=0d3d9d58&scoped=true&lang=css&"
import style1 from "./New.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3d9d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d3d9d58')) {
      api.createRecord('0d3d9d58', component.options)
    } else {
      api.reload('0d3d9d58', component.options)
    }
    module.hot.accept("./New.vue?vue&type=template&id=0d3d9d58&scoped=true&", function () {
      api.rerender('0d3d9d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SuperAdmin/Users/New.vue"
export default component.exports